<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    label="Name"
                    v-model="form.name"
                    outlined
                    dense
                    hide-details="auto"
                    clearable
                >
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "MeasureUnitListSearch",
    data() {
        return {
            form : {
                name: ""
            }
        }
    },
    computed: {
        ...mapGetters({
            params: "warehouse/measureUnit/list/params"
        })
    },
    methods: {
        ...mapActions({
            updateParams: "warehouse/measureUnit/list/updateParams"
        }),
        submit() {
            this.updateParams(this.form)
        }
    },
    mounted() {
        this.form = {...this.form, ...this.params}
    }
}
</script>

<style>
</style>